import React from "react";

export default function AuditLog() {
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="box-header">
                  <div className="row">
                    <div className="col-md-6">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb breadcrumb_bg">
                          <li className="breadcrumb-item">
                            <a href="#" className="breadcrumb_1">
                              Audit Log
                            </a>
                          </li>
                          <li
                            className="breadcrumb-item active breadcrumb_2"
                            aria-current="page"
                          >
                            Action Log
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>

                <div className="box-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          Account Selection
                        </label>
                        <select className="form-control" name="account">
                          <option value="">--Select Account --</option>
                          <option value="2">Admin</option>
                          <option value="5">Customer Care</option>
                          <option value="6">Mis Management</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="form-group">
                        <label className="font-weight-bold d-block invisible">
                          submit
                        </label>
                        <button type="submit" className="btn btn-primary mb-2">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li
                        className="nav-item position-relative"
                        role="presentation"
                      >
                        <a
                          className="nav-link active"
                          id="home-tab"
                          data-toggle="tab"
                          href="#home"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                        >
                          Audit Log
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active pt-2"
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        <table
                          id="Sub_table"
                          className="table table-bordered table-striped table-sm"
                        >
                          <thead>
                            <tr className="table-info">
                              <th>Audit Id</th>
                              <th>Name</th>
                              <th>Action</th>
                              <th>Date Time</th>
                              <th>Sub Menu</th>
                              <th>Message</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ wordBreak: "break-all" }}>56</td>
                              <td style={{ wordBreak: "break-all" }}>Henry</td>
                              <td style={{ wordBreak: "break-all" }}>Sale</td>
                              <td style={{ wordBreak: "break-all" }}>
                                23-05-20
                              </td>
                              <td style={{ wordBreak: "break-all" }}>Nill</td>
                              <td style={{ wordBreak: "break-all" }}>None</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* <div className="col-md-12 p-0 mt-2">
                          <div className="card">
                            <div className="card-body p-2">
                              <p className="card_text mb-0 text-center font-weight-bold text-muted">
                                No Record Found...!!
                              </p>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
